export const ENVIRONMENTS = ['prod', 'dev', 'staging', 'test'] as const;
export type Environment = (typeof ENVIRONMENTS)[number];

const ENVIRONMENT_MAPPING: Record<string, Environment> = {
  production: 'prod',
  prod: 'prod',
  development: 'dev',
  dev: 'dev',
  staging: 'staging',
  test: 'test',
};

export const API_URL = process.env.API_URL;
export const APP_ENV: Environment = process.env.APP_ENV ? ENVIRONMENT_MAPPING[process.env.APP_ENV] : 'dev';
export const APP_VERSION = process.env.APP_VERSION;
